import { ComponentProps, ComponentType } from 'react';
import { AsyncBoundary } from '@toss/async-boundary';
import { useIsMounted } from '@toss/react';

/**
 * Page router 에서 Suspense 사용 시 발생하는 Hydration 관련 문제를 방지할 수 있는 Async Boundary Wrapper 컴포넌트
 *
 * SSR 또는 SSG 에서는 무조건 pendingFallback 이 렌더링되고, 클라이언트 사이드에서는 Async Boundary 와 동일하게 작동한다.
 */
export function SSRSafeAsyncBoundary(props: ComponentProps<typeof AsyncBoundary>) {
  const isMounted = useIsMounted();
  if (isMounted) {
    return <AsyncBoundary {...props} />;
  }
  return <>{props.pendingFallback}</>;
}

/**
 * SSRSafeSuspense 컴포넌트의 HOC 형태
 */
export function withSSRSafeAsyncBoundary<P extends JSX.IntrinsicAttributes>(Component: ComponentType<P>, asyncBoundaryProps: ComponentProps<typeof AsyncBoundary>) {
  return function WithSSRSafeSuspense(props: P) {
    return <SSRSafeAsyncBoundary {...asyncBoundaryProps}>
        <Component {...props} />
      </SSRSafeAsyncBoundary>;
  };
}